import { Box, styled } from '@mui/material';

export const LandingPageStyle = styled(Box)(({ theme }) => ({
    background:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg, #000000 0%, #232326 100%);'
            : 'linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%)',

    display: 'flex',
    alignItems: 'flex-start',
    height: '100dvh',

    '& .body-content': {
        width: 'calc(100% - 75px)',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        },
    },
}));
